import { Modal } from "@circle-react-shared/uikit/ModalV2";
import { Loader } from "@circle-react-uikit/Loader";

export const EditPostLoader = () => (
  <Modal.Content className="flex min-h-[400px] items-center justify-center">
    <Loader />
  </Modal.Content>
);
